import { useEffect } from 'react';
import { create } from 'zustand';
import { getCrmCustomers, CrmCustomer } from '../services/api';

/**
 * 選單用的參考資料：CRM 客戶（發票客戶，照 PM stores/lookupStore.ts）
 * 每次開啟網頁抓一次，各對話框共用；失敗時下次再試
 */
let customersRequest: Promise<void> | null = null;

const useLookupStore = create<{ customers: CrmCustomer[]; loadCustomers: () => Promise<void> }>()((set) => ({
  customers: [],
  loadCustomers: () =>
    (customersRequest ??= getCrmCustomers()
      .then(res => set({ customers: res.data }))
      .catch(error => {
        customersRequest = null;
        console.error('Failed to load CRM customers:', error);
      })),
}));

/** CRM 客戶（第一次用到時載入） */
export const useCrmCustomers = () => {
  const { customers, loadCustomers } = useLookupStore();
  useEffect(() => { loadCustomers(); }, [loadCustomers]);
  return customers;
};
